import ShopDetails from "../Components/Shop/shop-details/ShopDetails.tsx";

const Shop = () => {
  return (
    <>
      <ShopDetails />
    </>
  );
};

export default Shop;
